import { Component, Input } from '@angular/core';
import { documentToHtmlString } from 'src/app/component/card/api-information-card/index';
import { ConnectCard } from 'src/app/model/card/connect-card';
import { config } from 'src/environments/environment';

declare var gtag: any;

@Component({
  selector: 'app-connect-card',
  templateUrl: './connect-card.component.html',
  styleUrls: ['./connect-card.component.scss']
})
export class ConnectCardComponent {
  @Input() titleHeading: string = '';
  @Input() connectCard: ConnectCard[] = [];

  constructor() {}
  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }

  handleCardBodyClick(event: Event): void {
    const anchor = (event.target as HTMLElement)?.closest('a');
    if (!anchor) {
      return;
    }
    if (this.shouldTrackFaqPortalClick(anchor)) {
      gtag('event', 'ndc_agency_portalFAQ_link_click', {
        event_category: 'Connect Card',
        event_label: anchor.textContent?.trim() || 'British Airways NDC Agency Portal',
        destination_url: anchor.pathname,
        transport_type: 'beacon'
      });
    }
  }

  private shouldTrackFaqPortalClick(anchor: HTMLAnchorElement): boolean {
    const isFaqPortalLink = anchor.pathname.toLowerCase().includes('faq-portal');
    const isAnalyticsAvailable = config.enableCookies && typeof gtag !== 'undefined';
    return isFaqPortalLink && isAnalyticsAvailable;
  }
}